import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonLink,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text2,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, {useEffect} from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { observer, useLocalObservable } from "mobx-react-lite";
import { PostBalanceInquiryRequestFetchStore } from "../../../stores";
import { useNavigateCustom, useOpenFGTSApp } from "../../../hooks";
import { useAnalytics } from "../../../hooks/useAnalytics";

export const AnniversaryMembershipEgress: React.FC = observer(() => {
	const errorInfo = strings.components.connectionFeedback.errors;
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const { isDesktopOrBigger } = useScreenSize();
	const { authenticationStore } = useGlobalStore();
	const navigation = useNavigateCustom();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(
			authenticationStore,
			() => navigation("/connect-fgts-balance"),
		),
	);

	const handleAddAnalyticEvent = (description: string ): void => {
		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description,
			step: "fgts:retomar-saque-aniversario",
			value: "",
		}, {applySanitize: true});
	};

	const handleOnPressButton = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.anniversaryMembershipEgress.buttons.primaryButton);
		store.fetchShelf.fetch();
	};

	const handleOnPressLink = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.anniversaryMembershipEgress.buttons.linkButton);
		useOpenFGTSApp();
	};

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "retomar-saque-aniversario",
			step: "fgts:retomar-saque-aniversario",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Retomar Saque Aniversário",
			pagePath: "/fgts/retomar-saque-aniversario",
		});
	},[]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.anniversaryMembershipEgress.title}
						description={errorInfo.anniversaryMembershipEgress.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={handleOnPressButton}
								showSpinner={store.fetchShelf.loader.isLoading}
								disabled={store.fetchShelf.loader.isLoading}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.anniversaryMembershipEgress.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
							{!isDesktopOrBigger && (
								<ButtonLink
									onPress={handleOnPressLink}
									disabled={store.fetchShelf.loader.isLoading}
								>
									<Text2 medium color={skinVars.colors.textLink}>
										{errorInfo.anniversaryMembershipEgress.buttons.linkButton}
									</Text2>
								</ButtonLink>
							)}
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default AnniversaryMembershipEgress;
